import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { userDetails } from "store/actions/authAction"

/**
 * Keeps Redux/localStorage role permissions in sync with the server.
 * Refreshes on mount and when the user returns to the tab (focus / visibility).
 */
const usePermissionRefresh = () => {
  const dispatch = useDispatch()
  const isLoggedIn = useSelector(state => state.Login?.isLoggedIn)

  useEffect(() => {
    if (!isLoggedIn) {
      return undefined
    }

    const refreshPermissions = () => {
      dispatch(userDetails())
    }

    refreshPermissions()

    const onFocus = () => refreshPermissions()
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshPermissions()
      }
    }

    window.addEventListener("focus", onFocus)
    document.addEventListener("visibilitychange", onVisibilityChange)

    return () => {
      window.removeEventListener("focus", onFocus)
      document.removeEventListener("visibilitychange", onVisibilityChange)
    }
  }, [dispatch, isLoggedIn])
}

export default usePermissionRefresh
